module.exports = __webpack_public_path__ + "img/logo-1.b2910da2.svg";